module.exports = __webpack_public_path__ + "static/UNB-3853fb4af04931d285d3b445fa018206.otf";